import { Popover as AntdPopOver } from 'antd';

const PopOver = (props) => {
  const {
    title = '',
    content = '',
    children = '',
    placement = 'bottomLeft',
    trigger = 'hover',
    arrow = false,
    overlayClassName = '',
    overlayInnerStyle = '',
    visible = false,
    setVisible = () => {},
    className = '',
  } = props;

  return (
    <AntdPopOver
      title={title}
      content={content}
      placement={placement}
      trigger={trigger}
      arrow={arrow}
      overlayInnerStyle={overlayInnerStyle}
      overlayClassName={overlayClassName}
      open={visible}
      onOpenChange={setVisible}
      rootClassName={className}
    >
      {children}
    </AntdPopOver>
  );
};
export default PopOver;
